import React, { FC } from 'react';

interface ReplacementPartsTaggedProductsListProps {
  label: string;
  products: string[];
}

const ReplacementPartsTaggedProductsList: FC<
  ReplacementPartsTaggedProductsListProps
> = (props) => {
  const { label, products } = props;

  return products.length ? (
    <div className="my-10 border-y py-6">
      <p>{label}</p>
      <ul className="ml-0 list-disc pl-6 text-left">
        {products &&
          products.map((product) => (
            <li className="mt-4" key={product}>
              {product}
            </li>
          ))}
      </ul>
    </div>
  ) : null;
};

export default ReplacementPartsTaggedProductsList;
